import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Box,
  Stack
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Iconify from '../iconify';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 16,
    padding: theme.spacing(2),
    minWidth: 400,
    maxWidth: 500,
    textAlign: 'center',
    position: 'relative'
  }
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  color: theme.palette.grey[500],
  '&:hover': {
    backgroundColor: theme.palette.grey[100]
  }
}));

const SuccessModal = ({ open, onClose }) => {
  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <CloseButton onClick={onClose}>
        <Iconify icon="eva:close-fill" />
      </CloseButton>
      
      <DialogContent>
        <Stack spacing={3} alignItems="center">
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'success.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2
            }}
          >
            <Iconify 
              icon="eva:checkmark-circle-2-fill" 
              sx={{ 
                width: 48, 
                height: 48, 
                color: 'success.main' 
              }} 
            />
          </Box>
          
          <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary' }}>
            ¡Muchas gracias!
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'text.secondary',
              lineHeight: 1.6,
              px: 2
            }}
          >
            Muchas gracias por enviarnos esa solicitud, estaremos en contacto con usted dentro de un plazo de 7 días laborales.
          </Typography>
        </Stack>
      </DialogContent>
    </StyledDialog>
  );
};

export default SuccessModal;